module.exports = __webpack_public_path__ + "static/7-d05cb366e2c51922f2b1d32de93d4323.png";